module.exports = __webpack_public_path__ + "static/Recursive_VF_1.065-0ec47ba6e42b9a8beb97728c75a3e129.woff2";